export const setPaymentStatus = (state, param) => {
  state.list = param
}

export const setPaymentOmise = (state, param) => {
  state.omise.public_key = param.public_key
  state.omise.secret_key = param.secret_key
  state.omise.currency_id = param.currency_id
  state.omise.rmp_user = param.rmp_user
  state.omise.update_date = param.update_date
}

export const setPaymentOmiseCurrencies = (state, param) => {
  state.omise.currency_list = param.currency
}

export const setCheckPaymentCurrency = (state, param) => {
  state.check_currency = param
}

export const setPaymentPaypal = (state, param) => {
  state.paypal.client_id = param.client_id
  state.paypal.secret = param.secret
  state.paypal.rmp_user = param.rmp_user
  state.paypal.update_date = param.update_date
}

export const setKpayment = (state, param) => {
  state.kpayment.merchantId = param.merchant_id
  state.kpayment.publicKey = param.public_key
  state.kpayment.secretKey = param.secret_key
  state.kpayment.updateDate = param.update_date
  state.kpayment.rmpUser = param.rmp_user
}

export const setPaymentPaypalCurrencies = (state, param) => {
  state.paypal.currency_list = param.currency
}

export const setPaymentTransfer = (state, param) => {
  state.transfer.type = param.type
  state.transfer.manual_text = param.manual_text
}

export const setPaymentLists = (state, param) => {
  state.payment_lists = param
}



// WEBPACK FOOTER //
// ./src/store/modules/payments/mutations.js